import './BookmarksFilter.css';
import Select from 'components/UIComponents/Select';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { useMemo } from 'react';

type Props = {
  bookmarksData: {
    bookmarksCount: number;
    claimsBookmarksCount: number;
    contractsBookmarksCount: number;
    matchingBookmarksCount: number;
    myBookmarksCount: number;
    allBookmarksCount: number;
  };
  handleSelectChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const BookmarksFilter = ({
  bookmarksData: {
    bookmarksCount,
    claimsBookmarksCount,
    contractsBookmarksCount,
    myBookmarksCount,
    allBookmarksCount,
    matchingBookmarksCount,
  },
  handleSelectChange,
}: Props) => {
  const options = useMemo(() => {
    return [
      {
        label: `All bookmarks (${allBookmarksCount})`,
        value: '',
      },
      {
        label: `My bookmarks (${myBookmarksCount})`,
        value: 'myBookmarks',
      },
      {
        label: `Claims bookmarks (${claimsBookmarksCount})`,
        value: SectionType.Claims,
      },
      {
        label: `Contracts bookmarks (${contractsBookmarksCount})`,
        value: SectionType.Contracts,
      },
      {
        label: `Matching bookmarks (${matchingBookmarksCount})`,
        value: SectionType.Matching,
      },
    ];
  }, [
    claimsBookmarksCount,
    contractsBookmarksCount,
    myBookmarksCount,
    allBookmarksCount,
    matchingBookmarksCount,
  ]);
  return (
    <section className="bookmarks-page__filter">
      <h3>{bookmarksCount} Bookmarks</h3>
      <Select options={options} onChange={handleSelectChange}></Select>
    </section>
  );
};
